const glass = "_glass_1x9g9_17";
const styles = {
  glass
};
export {
  styles as default,
  glass
};
//# sourceMappingURL=Glass.module.css.js.map
